// Traduz mensagens de erro do backend (em inglês) para o usuário final.
// Chaves comparadas em minúsculas; texto desconhecido volta como veio.

const AUTH_ERROR_PT = {
  'invalid email or password': 'E-mail ou senha inválidos',
  'account suspended': 'Conta suspensa. Contate o administrador.',
  'password change required': 'É necessário alterar sua senha no primeiro acesso',
  'password change not required': 'Esta conta não exige troca de senha. Faça o login normalmente.',
  'invalid authentication': 'Sessão inválida. Faça login novamente.',
  'user not found': 'Usuário não encontrado',
  'missing authorization header': 'Sessão inválida. Faça login novamente.',
  'registration closed. contact administrator.': 'Cadastro encerrado. Contate o administrador.',
};

const RATE_LIMIT_MSG = 'Muitas tentativas. Aguarde um minuto e tente novamente.';

/**
 * Converte um erro do axios (ou qualquer objeto com response/message)
 * em uma mensagem em português pronta para o toast.
 */
export function traduzErroAuth(error, fallback = 'Erro ao fazer login') {
  const status = error?.response?.status;
  const data = error?.response?.data;

  if (status === 429) return RATE_LIMIT_MSG;

  let raw = '';
  if (typeof data === 'string') raw = data;
  else if (data && typeof data.detail === 'string') raw = data.detail;
  else if (data && typeof data.error === 'string') raw = data.error;
  else if (data && typeof data.message === 'string') raw = data.message;

  if (raw) {
    const key = raw.trim().toLowerCase();
    if (AUTH_ERROR_PT[key]) return AUTH_ERROR_PT[key];
    if (key.startsWith('rate limit exceeded')) return RATE_LIMIT_MSG;
    if (status >= 500) return 'Erro no servidor. Tente novamente em instantes.';
    return raw;
  }

  if (status >= 500) return 'Erro no servidor. Tente novamente em instantes.';
  if (!error?.response) return 'Erro de conexão com o servidor. Verifique sua internet.';
  return fallback;
}
